import { FC } from 'react';

import { Box } from '@mui/material';

import { useDataContext } from 'components/OnePageTemplates/context';

interface IProps {
  className?: string;
}

export const LogoContainer: FC<IProps> = ({ className }) => {
  const {
    data: { companyLogo },
  } = useDataContext();

  return (
    <>
      {companyLogo && typeof companyLogo === 'string' ? (
        <img className={className} src={companyLogo} alt="Example logo" />
      ) : (
        <Box className={className}>{companyLogo}</Box>
      )}
    </>
  );
};
